import React, {useEffect, useState} from 'react';
import {useParams} from 'react-router-dom'
import {Alert, Box, Button, Theme} from '@mui/material';
import makeStyles from '@mui/styles/makeStyles';
import {LoadingProgress, MostrarError} from "../../components";
import {getPublicUser} from "../../services";
import {setEnums} from "../../redux/reducers/enumsReducers";
import {setUsosMultiples} from "../../redux/reducers/usosMultiplesReducers";
import {setPaises} from "../../redux/reducers/paisesReducers";
import DetallesSolicitud from "./DetallesSolicitud";
import {geoString, getLSLang, mapApiOptions, setLSLang, translateText} from "../../helpers";
import Strings from "../../assets/strings";
import {setCurrentUser} from "../../redux/reducers/authReducer";
import {setCompania as setGlobalCompania} from "../../redux/reducers/companiasReducers";
import {LoadScript} from "@react-google-maps/api";
import {isMobile} from "../../helpers/browser_detect";
import {useAppDispatch, useAppSelector} from "../../redux/hooks";
import {ICompania} from "../../redux/types/ICompania";
import Notifications from "react-notification-system-redux";
import {IKeyValue} from "../../redux/types/Icommon";

const style = {
    NotificationItem: { // Override the notification item
        DefaultStyle: { // Applied to every notification, regardless of the notification level
            margin: '10px 5px 2px 1px',
            borderRadius: '0px',
            boxShadow:"none",
        },
    },
    Dismiss: {
        DefaultStyle: {
            backgroundColor: "none",
            color: '#bbbbbb',
        },
    }
};
const useStyles = makeStyles((theme:Theme) => ({
    root:{
        boxShadow: "#969696 0px 0px 12px",
        maxWidth: 990,
        margin: "-69px auto 30px auto",
        boxSizing: "border-box",
        background:"#fff",
        [theme.breakpoints.down('md')]: {
            marginTop:-71,
            "& h1":{
                display:"none"
                // marginTop: "-64px !important",
                // color: "white  !important",
                // marginBottom: "39px !important",
            }
        }


    },
    topHead: {
        display: "flex",
        justifyContent: "space-between",
        textAlign: "right",
        height: "103px",
        alignItems: "center",
        padding: theme.spacing(2),
        borderBottom: "1px solid #ddd",
        "& .info":{
            display: 'flex',
            alignItems: "center",
        },
        "& h1":{
            color:theme.palette.secondary.main,
            fontWeight: "normal",
            margin: "0",
            fontSize: "1.5rem",
            minWidth: 254,
            textAlign: "left",
            textTransform: "uppercase",

        },
        "& h2":{
            color:theme.palette.primary.main,
            fontWeight: "normal",
            margin: "0",
            fontSize: "1.4rem",
        },
        "& .logo":{
            marginLeft: 10,
            maxWidth: 180,
            textAlign: "left",
            "& img":{
                maxWidth: "100%",
                maxHeight: 99,
            },
        },
        "& span":{
            padding: 0,
            "&.tel":{
                fontSize:".9rem",
            },
            "&.dir":{
                fontSize:".7rem",
            }
        },
        [theme.breakpoints.down('md')]: {
            flexDirection: "column",
            height: "auto",
            "& .info":{
                flexDirection: "column-reverse",
                textAlign: "center",
            },
            "& h1":{
                textAlign: "center",
            }
        }
    },
    lang:{
        textAlign: "center",
        marginBottom: theme.spacing(3),
        "& select":{
            padding: 5,
            fontSize: "1em",
        }
    },
    webview:{
        boxShadow:"none",
        margin:0,
        padding:0,
        "&>div":{
            padding:theme.spacing(1),
        }
    }
}));
export default function Solicitar(){
    let { user } = useParams();
    let dispatch = useAppDispatch();
    const webview = isMobile.anyWebView();
    const notifications = useAppSelector(state => state.notifications);

    const classes = useStyles();
    const [loaded, setLoaded] = useState(false);
    const [compania, setCompania] = useState<ICompania & {permitirDocumentos?:boolean}>({});
    const [error, setError] = useState();
    const [lang, setLang] = useState(getLSLang("l"));
    useEffect(()=>{
        if(user) {
            getPublicUser(user).then((res) => {
                let enums = res?.data?.enums ?? {};
                let paises = res?.data?.paises ?? {};
                paises = paises.map((p: any) => ({id: p.key, nacionalidad: p.value}));

                let companiaData = res?.data ?? {};
                delete companiaData.enums;
                delete companiaData.paises;

                setCompania(companiaData); //local
                dispatch(setGlobalCompania(companiaData)); //global
                dispatch(setPaises(paises)); //global
                dispatch(setUsosMultiples({
                    3:enums.parentescos?.map((p:IKeyValue)=>({id:p.key, tipo:3, descripcion:p.value}))
                })); //global

                dispatch(setEnums(enums)); //global
                dispatch(setCurrentUser({uiColor: companiaData?.uiColor})); //Global
                //,genLocalidad:compania?.genLocalidad esto estaba antes

                setLoaded(true);

            }).catch((e) => setError(e?.response))
        }
    },[user,setCompania,setLoaded,dispatch,setError])


    return(
            // @ts-ignore
            <LoadScript {...{...mapApiOptions,language:getLSLang("l")}}>
                {!loaded?(
                    error ? <MostrarError errors={error} action={false}/> : <LoadingProgress vh />
                ):(
                    <>
                        {!webview && <Box bgcolor="primary.main" width={"100%"} height={138} />}

                        <Box sx={{display:"inline-flex",position: "absolute", left: "calc(50% - 155px)", top: "18px"}}>
                            <Button sx={{color:"#CDDC39"}} variant={"text"} size="small">Solicitar Préstamo</Button>
                            <Button sx={{color:"#fff"}} href={window.location.origin+`/estadoCliente/${user}`}
                                    variant={"text"} size="small">Consultar Estado</Button>
                        </Box>

                        <div className={classes.root+(webview?" "+classes.webview:"")}>
                            {!webview &&
                                <>
                                    <div className={classes.topHead}>
                                        <h1>{Strings.solicitud} {Strings.prestamo}</h1>
                                        <div className="info">
                                            <div>
                                                <h2>{compania?.nombre}</h2>
                                                <span className="tel">
                                            <i>
                                                {!!compania?.rnc && <><span>{geoString("rnc",true)}: {compania?.rnc}</span> <br/></>}
                                                {!!compania?.telefono && <span> Tel: {compania?.telefono}</span>}
                                                {!!compania?.telefono2 && <span> &nbsp;/ &nbsp; {compania?.telefono2}</span>}
                                            </i>
                                        </span>
                                                <br/>
                                                <span className="dir">{compania?.direccion}</span>
                                            </div>
                                            {!!compania?.logo &&
                                                <div className="logo">
                                                    <img alt="logo" src={compania?.logo} />
                                                </div>
                                            }
                                        </div>
                                    </div>
                                    <Alert severity="info"> Para aumentar la probabilidad de que su solicitud sea aprobada, proporcione la mayor cantidad de datos posible.</Alert>
                                </>
                            }
                            {/*sx={{textTransform:"none"}}*/}
                            <DetallesSolicitud lang={lang} permitirDocumentos={compania.permitirDocumentos}/>
                        </div>
                        {!webview &&
                            <div className={classes.lang}>
                                <select value={lang} onChange={e=>{
                                    let lang = e.target.value;
                                    setLSLang(lang);
                                    Strings.setLanguage(lang);
                                    setLang(lang);
                                }}>
                                    {Strings.getAvailableLanguages().map(l=>
                                        <option key={l} value={l}>{translateText(l)}</option>
                                    )}
                                </select>
                            </div>
                        }
                        <br/>
                    </>
                )}
                <Notifications notifications={notifications} style={style} />

            </LoadScript>
        );
}

